<template>
  <div>
    <div class="tab-inner-form">
      <div></div>
      <div>
        <el-radio-group
          v-model="config.status"
          @change="getlist">
          <el-radio-button :label="0">未发放</el-radio-button>
          <el-radio-button :label="1">已发放</el-radio-button>
        </el-radio-group>
        <el-radio-group
          v-model="config.appraisalType"
          style="margin-left: 10px"
          @change="getlist">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="1">鉴定意见书</el-radio-button>
          <el-radio-button :label="2">商家防伪扣</el-radio-button>
        </el-radio-group>
        <el-input
          v-model="config.vendorName"
          clearable
          style="width: 240px;margin-left: 10px"
          placeholder="请输入商家名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </div>
    </div>
    <el-table
      border
      :data="list">
      <el-table-column
        label="商家名称"
        min-width="120"
        prop="vendorName"></el-table-column>
      <el-table-column
        label="申请数量"
        min-width="100"
        prop="applyCount"></el-table-column>
      <el-table-column
        label="发放数量"
        min-width="100"
        prop="provideCount"></el-table-column>
      <el-table-column
        label="吊扣类型"
        width="100"
        prop="appraisalType">
        <template slot-scope="{ row }">{{ row.appraisalType === 1 ? '鉴定意见书' : '商家防伪扣' }}</template>
      </el-table-column>
      <el-table-column
        label="发放状态"
        min-width="100"
        prop="status">
        <template slot-scope="{ row }">{{ row.status === 0 ? '未发放' : '已发放' }}</template>
      </el-table-column>
      <el-table-column
        label="申请时间"
        width="150"
        prop="createdTime">
        <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
      </el-table-column>
      <el-table-column
        label="发放时间"
        width="150"
        prop="provideTime">
        <template slot-scope="{ row }">{{ row.provideTime | dateformat() }}</template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="50">
        <template slot-scope="{ row }">
          <el-button
            :disabled="row.status === 1"
            type="text"
            @click="provideTag(row)">发放</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      slot="footer"
      background
      style="text-align:center"
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange"></el-pagination>
    <provide-tag-modal
      ref="provide"
      :callback="getlist" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ProvideTagModal from './provide-tag-modal.vue'
export default {
  name: 'TagApplyTable',
  components: { ProvideTagModal },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: { pageNum: 1, pageSize: 10, vendorName: '', status: 0, appraisalType: null }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('appraise/getappraisaltagapplys', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    provideTag(row) {
      const { id, vendorName, applyCount, appraisalType } = row
      this.$refs.provide.init({ id, vendorName, applyCount, appraisalType, provideCount: applyCount })
    }
  }
}
</script>
